<div class="base-modal">
  <span class="base-modal__close-button" (click)="closeModal()">
    <i class="material-icons"> close </i>
  </span>
  <div class="base-modal__header">
    <h2 class="base-modal__title">Shopify connection</h2>
  </div>

  <form [formGroup]="shopifyForm">
    <div class="base-modal__body">
      <div class="brn-form-field">
        <input type="text" formControlName="shop" placeholder="yourshop.myshopify.com" />
      </div>
  
    </div>

    <div class="base-modal__footer">
      <!-- --------------------------- New connection ---------------------------- -->
      <ng-container *ngIf="newConnection">
        <button
          class="button button--flat"
          (click)="createConnection()"
          [ngClass]="{ 'button--disabled': !validForm }"
        >
          Create connection
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
      </ng-container>
      <!-- --------------------------- Edit connection --------------------------- -->

      <ng-container *ngIf="!newConnection">
        <button
          class="button button--flat"
          (click)="updateConnection()"
          [ngClass]="{ 'button--disabled': !validForm }"
        >
          Save changes
          <i *ngIf="pendingStatus" class="material-icons button__loader">
            rotate_right
          </i>
        </button>
        <button
          class="button button--flat button--danger"
          (click)="removeConnection()"
        >
          Remove connection
        </button>
      </ng-container>
    </div>
  </form>
</div>
